module.exports = __webpack_public_path__ + "img/insrtuction1.491904eb.jpg";